import { MessageTypes } from 'common';
import { languageAndTimeZone, networkInfo, sanitizeSettingsForAnalytics } from './analiticsUtils';
import { createOrderFacade } from './createOrderFacade';
import { InitializationErrorsCode } from './Errors/InitializationErrors';
import { storage } from './Services/storage';
import { renderError, renderUI } from './View';
import { recording } from './openReplay';
import { FeatureFlag } from './View/Contexts/FeatureFlagContext';
import { removeUserToken } from './Services/userToken';
import { getMerchant } from './Models/Merchant/Merchant';
const BootstrapWidget = (container, settings) => {
    var _a, _b;
    window.analytics.load(process.env.REACT_APP_CUSTOMER_IO_API_KEY);
    window.analytics.page();
    const bootstrapTimestamp = new Date().getTime();
    const initBootstrapDelta = (settings === null || settings === void 0 ? void 0 : settings.analyticsInfo)
        ? bootstrapTimestamp - (settings === null || settings === void 0 ? void 0 : settings.analyticsInfo.initTimestamp)
        : 'unknown';
    const analyticsData = Object.assign(Object.assign(Object.assign(Object.assign({}, networkInfo()), languageAndTimeZone()), { initBootstrapDelta,
        bootstrapTimestamp, apiKey: settings === null || settings === void 0 ? void 0 : settings.apiKey, initTimestamp: (_a = settings === null || settings === void 0 ? void 0 : settings.analyticsInfo) === null || _a === void 0 ? void 0 : _a.initTimestamp, merchantUrl: (_b = settings === null || settings === void 0 ? void 0 : settings.analyticsInfo) === null || _b === void 0 ? void 0 : _b.merchantUrl }), sanitizeSettingsForAnalytics(settings));
    // Track with Customer.io (legacy)
    window.analytics.track('Widget Initialized', analyticsData);
    // Statsig tracking removed to prevent excessive network requests
    window.addEventListener('focus', () => {
        window.analytics.track('user_focus_inside_widget_frame');
        // Statsig tracking removed to prevent excessive network requests
    });
    window.addEventListener('blur', () => {
        window.analytics.track('user_focus_outside_widget_frame');
        // Statsig tracking removed to prevent excessive network requests
    });
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            window.analytics.track('user_moved_to_other_tab');
            // Statsig tracking removed to prevent excessive network requests
        }
        else if (document.visibilityState === 'visible') {
            window.analytics.track('user_returned_to_widget_tab');
            // Statsig tracking removed to prevent excessive network requests
        }
    });
    storage.API_KEY.set(settings.apiKey);
    getMerchant()
        .then((merchant) => {
        var _a;
        const clearSessionFeatureEnabled = (_a = merchant.features) === null || _a === void 0 ? void 0 : _a.includes(FeatureFlag.CLEAR_SESSION_ON_INIT);
        if (clearSessionFeatureEnabled) {
            storage.clearAll();
            removeUserToken();
            storage.API_KEY.set(settings.apiKey);
        }
        return createOrderFacade(settings);
    })
        .then((result) => {
        var _a, _b;
        const [{ orderFacade, stepController }, currencies, merchant] = result;
        const clearSessionFeatureEnabled = (_a = merchant.features) === null || _a === void 0 ? void 0 : _a.includes(FeatureFlag.CLEAR_SESSION_ON_INIT);
        if (clearSessionFeatureEnabled) {
            stepController.reset();
        }
        if (settings.forceNewTransaction) {
            storage.clearAll();
            storage.API_KEY.set(settings.apiKey);
            stepController.reset();
        }
        if (settings.orderToken) {
            storage.clearAll();
            storage.TOKEN.set(settings.orderToken);
            storage.API_KEY.set(settings.apiKey);
        }
        recording.start({ userID: (_b = orderFacade.order) === null || _b === void 0 ? void 0 : _b.uid });
        return result;
    })
        .then((result) => {
        // Track successful app initialization
        // Statsig tracking removed to prevent excessive network requests
        return renderUI(container, settings, result);
    })
        .catch((err) => {
        const errorCode = err.errorCode || InitializationErrorsCode.UnknowingError;
        // Track initialization error
        // Statsig tracking removed to prevent excessive network requests
        renderError(container, settings, errorCode);
    })
        .finally(() => {
        container.classList.remove('loader');
    });
};
const rootEl = document.getElementById('root');
window.addEventListener('message', (event) => {
    const data = event.data || {};
    if (data.type === MessageTypes.START_APPLICATION && rootEl) {
        const settings = data.payload;
        BootstrapWidget(rootEl, settings);
    }
});
